import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import Pictures from "../../containers/Sell/PicturesContainer";
import SearchContainer from "../../containers/Sell/SearchContainer";
import CarSearchInformation from "../../containers/Sell/CarSearchInformationContainer";
import Records from "../../containers/Sell/RecordsContainer";
import CarDetail from "../../containers/Sell/CarDetailContainer";
import Confort from "../../containers/Sell/ConfortContainer";
import Tags from "../../containers/Sell/TagsContainer";
import ValueAndPayment from "../../containers/Sell/ValueAndPaymentContainer";
import Location from "../../containers/Sell/LocationContainer";
import Brand from "../../containers/Sell/BrandContainer";
import Year from "../../containers/Sell/YearContainer";
import Model from "../../containers/Sell/ModelContainer";
import ScheduleInspection from "../../containers/Sell/ScheduleInspectionContainer";
import Detail from "../../containers/Sell/DetailContainer";
import Description from "../../containers/Sell/DescriptionContainer";
import CongratulationsPage from "../CongratulationsPage";
import CongratulationsPageSell from "../../containers/CongratulationPageSell/CongratulationSellContainer";

const EntryPoint = React.lazy(() => import("./EntryPoint"));

const sellSubRoutes: RouteObject[] = [
    {
        title: "Sell",
        path: "publicar",
        component: <SearchContainer/>
    },
    {
        title: "Location",
        path: "pasos",
        component: <Location/>
    },
    {
        title: "Brand",
        path: "marca",
        component: <Brand/>
    },
    {
        title: "Year",
        path: "año",
        component: <Year/>
    },
    {
        title: "Model",
        path: "modelo",
        component: <Model/>
    },
    {
        title: "car Detail",
        path: "detalle-auto",
        component: <CarDetail/>
    },
    {
        title: "records",
        path: "records",
        component: <Records/>
    },
    {
        title: "Confort",
        path: "confort",
        component: <Confort/>
    },
    {
        title: "Tags",
        path: "tags",
        component: <Tags/>
    },
    {
        title: "Pictures",
        path: "imagenes",
        component: <Pictures/>
    },
    {
        title: "ValueAndPayment",
        path: "valor-y-pago",
        component: <ValueAndPayment/>
    },
    {
        title: "CarSearchInformation",
        path: "busqueda-de-auto",
        component: <CarSearchInformation/>
    },
    {
        title: "Schedule inspection",
        path: ":id/agendar-inspeccion",
        component: <ScheduleInspection/>
    },
    {
        title: "Detail",
        path: "detalle",
        component: <Detail/>
    },
    {
        title: 'Description',
        path: 'descripcion',
        component: <Description/>
    },
    {
        title: "Congratulations",
        path: "detalle/agradecimiento/venta",
        component: <CongratulationsPageSell />
    }
]

export const sellRoutes: RouteObject[] = [
    {
        title: "Sell",
        path: "/vender-auto",
        component: <EntryPoint/>,
        subRoutes: sellSubRoutes
    }
];